let mdiCssLoaded = false

function loadMdiCss(): void {
  if (mdiCssLoaded) {
    return
  }

  mdiCssLoaded = true
  void import("@mdi/font/css/materialdesignicons.css")
}

export function scheduleNonCriticalAssets(): void {
  const requestIdle = globalThis.requestIdleCallback

  if (requestIdle !== undefined) {
    requestIdle(() => {
      loadMdiCss()
    })
    return
  }

  setTimeout(() => {
    loadMdiCss()
  }, 1)
}
